import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import LoginForm from "../forms/login/LoginForm";
import SignUpForm from "../forms/signup/SignUpForm";
import UserTypeComponent from "../usertype/UserTypeModal";
import styles from "./Navbar.module.css";
import logo from "./Blockenzyme.svg";
import logoIcon from "../footer/Logo.jpg";

const NavbarComponent = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [loginModalOpen, setLoginModalOpen] = useState(false);
  const [signupModalOpen, setSignupModalOpen] = useState(false);
  const [successModalOpen, setSuccessModalOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setIsOpen(false);
  }, [location]);

  const isActive = (path) => location.pathname === path;

  const navLinks = [
    { to: "/find-jobs", label: "Find Jobs" },
    { to: "/hire-employees", label: "Hire Employees" },
    { to: "/tech-workshops", label: "Tech Workshops" },
    { to: "/dev-services", label: "Dev Services", isNew: true },
    { to: "/about", label: "About" },
  ];

  return (
    <>
      <nav className={`${styles.navbar} ${scrolled ? styles.navbarScrolled : ""}`}>
        <div className={styles.navInner}>
          <Link to="/" className={styles.brand}>
            <img src={logoIcon} alt="Blockenzyme icon" className={styles.brandIcon} />
            <img src={logo} alt="Blockenzyme" className={styles.brandLogo} />
          </Link>

          <ul className={styles.navLinks}>
            {navLinks.map(({ to, label, isNew }) => (
              <li key={to}>
                <Link
                  to={to}
                  className={`${styles.navLink} ${isActive(to) ? styles.navLinkActive : ""}`}
                >
                  {isNew ? (
                    <span className={styles.navLinkNew}>
                      {label}
                      <span className={styles.redDot} />
                    </span>
                  ) : label}
                </Link>
              </li>
            ))}
          </ul>

          <div className={styles.navActions}>
            <button className={styles.btnSignup} onClick={() => setSignupModalOpen(true)}>
              Sign Up
            </button>
            <button className={styles.btnLogin} onClick={() => setLoginModalOpen(true)}>
              Log In
            </button>
          </div>

          <button
            className={styles.hamburger}
            onClick={() => setIsOpen(!isOpen)}
            aria-label="Toggle menu"
          >
            <span />
            <span />
            <span />
          </button>
        </div>
      </nav>

      {/* Mobile Menu */}
      <div className={`${styles.mobileMenu} ${isOpen ? styles.open : ""}`}>
        {navLinks.map(({ to, label, isNew }) => (
          <Link
            key={to}
            to={to}
            className={`${styles.mobileNavLink} ${isActive(to) ? styles.mobileNavLinkActive : ""}`}
          >
            {isNew ? (
              <span className={styles.navLinkNew}>
                {label}
                <span className={styles.redDot} />
              </span>
            ) : label}
          </Link>
        ))}
        <div className={styles.mobileDivider} />
        <div className={styles.mobileActions}>
          <button className={styles.btnSignup} onClick={() => { setSignupModalOpen(true); setIsOpen(false); }}>
            Sign Up
          </button>
          <button className={styles.btnLogin} onClick={() => { setLoginModalOpen(true); setIsOpen(false); }}>
            Log In
          </button>
        </div>
      </div>

      <Modal isOpen={loginModalOpen} toggle={() => setLoginModalOpen(false)} centered size="md">
        <ModalHeader toggle={() => setLoginModalOpen(false)} className="border-0 pb-0">
          <span style={{ fontSize: "1.4rem", fontWeight: 700, color: "#1a1a2e" }}>Welcome back</span>
        </ModalHeader>
        <ModalBody className="pt-0">
          <LoginForm onClose={() => setLoginModalOpen(false)} />
        </ModalBody>
      </Modal>

      <Modal isOpen={signupModalOpen} toggle={() => setSignupModalOpen(false)} centered size="md">
        <ModalHeader toggle={() => setSignupModalOpen(false)} className="border-0 pb-0">
          <span style={{ fontSize: "1.4rem", fontWeight: 700, color: "#1a1a2e" }}>Create your account</span>
        </ModalHeader>
        <ModalBody className="pt-0">
          <SignUpForm
            onClose={() => setSignupModalOpen(false)}
            onSuccess={() => { setSignupModalOpen(false); setSuccessModalOpen(true); }}
          />
        </ModalBody>
      </Modal>

      <Modal isOpen={successModalOpen} toggle={() => setSuccessModalOpen(false)} centered size="md">
        <ModalHeader toggle={() => setSuccessModalOpen(false)} className="border-0 pb-0">
          <span style={{ fontSize: "1.4rem", fontWeight: 700, color: "#1a1a2e" }}>You're almost there!</span>
        </ModalHeader>
        <ModalBody className="pt-0">
          <UserTypeComponent onClose={() => setSuccessModalOpen(false)} />
        </ModalBody>
      </Modal>
    </>
  );
};

export default NavbarComponent;
